<template>
  <div
    class="comment-card position-relative my-3 p-4"
    :class="{ 'comment-negative': !commentData.positiveCommentIsActive }"
  >
    <div
      class="
        comment-controller
        d-flex
        justify-content-between
        align-items-center
        w-100
        mb-2
      "
    >
      <div
        class="text-capitalize d-flex
        justify-content-between
        align-items-center comment-mode py-1"
      >
        <span class="circle" v-if="commentData.persona">
          <img
            class="img-fluid"
            :src="
              require(`@/assets/images/personas/${personaOrMode.toLowerCase()}.svg`)
            "
          />
        </span>
        <span class="px-1">{{ personaOrMode ? personaOrMode : "-" }}</span>
      </div>
      <div>
        <span
          class="cursor-pointer handle-opacity"
          :class="{
            'handle-opacity-active': starredCommentCondition,
          }"
          @click="starredComment()"
        >
          <img
            v-if="starredCommentCondition"
            src="@/assets/images/comments-page/fill_star_gold.svg"
            alt="starred"
            class="img-fluid"
          />
          <img
            v-else
            src="@/assets/images/comments-page/starred.svg"
            alt="starred"
            class="img-fluid"
          />
        </span>

        <span
          class="cursor-pointer handle-opacity"
          :class="{
            'handle-opacity-active': archivedCommentCondition,
          }"
          @click="archivedComment()"
        >
          <img
            src="@/assets/images/comments-page/archived.svg"
            alt="archived"
            class="mx-2 img-fluid"
          />
        </span>
      </div>
    </div>
    <p class="comments-text-description m-0" v-if="commentData">
      {{ comment }}
    </p>
    <div
      v-if="switchComment"
      class="
          switch-commnet
          cursor-pointer
        "
      @click="
        commentData.positiveCommentIsActive = !commentData.positiveCommentIsActive
      "
    >
      {{
        commentData.positiveCommentIsActive
          ? negativePlaceholder
          : positivePlaceholder
      }}
      <span class="text-decoration-underline">View</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    commentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      negativePlaceholder: "This user also has a negative comment.",
      positivePlaceholder: "This user also has a positive comment.",
    };
  },
  computed: {
    allCommentsIsPositive() {
      return this.$store.getters["mainStats/allCommentsIsPositive"];
    },
    personaOrMode() {
      return this.commentData.surveyType == "YEARLY"
        ? this.commentData.persona
        : this.commentData.mode;
    },
    comment() {
      return this.commentData.positiveCommentIsActive
        ? this.commentData.positiveComment
          ? this.commentData.positiveComment
          : "..."
        : this.commentData.negativeComment
        ? this.commentData.negativeComment
        : "...";
    },
    switchComment() {
      return this.commentData.positiveCommentIsActive
        ? this.commentData.negativeComment
          ? true
          : false
        : this.commentData.positiveComment
        ? true
        : false;
    },
    starredCommentCondition() {
      return this.commentData.positiveCommentIsActive
        ? this.commentData.positiveCommentStarred
          ? true
          : false
        : this.commentData.negativeCommentStarred
        ? true
        : false;
    },
    archivedCommentCondition() {
      return this.commentData.positiveCommentIsActive
        ? this.commentData.positiveCommentArchived
          ? true
          : false
        : this.commentData.negativeCommentArchived
        ? true
        : false;
    },
  },
  methods: {
    async starredComment() {
      let requestBody = {
        body: this.commentData,
        surveyId: this.$route.params.id,
        type: this.commentData.positiveCommentIsActive
          ? "positive"
          : "negative",
      };
      await this.$store.dispatch("mainStats/starredComment", requestBody);
    },

    async archivedComment() {
      let body = {
        body: this.commentData,
        surveyId: this.$route.params.id,
        type: this.commentData.positiveCommentIsActive
          ? "positive"
          : "negative",
      };
      await this.$store.dispatch("mainStats/archivedComment", body);
    },
  },
};
</script>

<style lang="scss" scoped>
.comment-card {
  border: 1px solid $color-grey-60;
  border-radius: $radius-33;
  height: max-content;
  .comment-controller {
    img {
      width: 1.25rem;
    }
  }
}

.comments-text-description,
.switch-commnet {
  padding: 0.5rem 1.5rem;
  border-radius: 2rem;
  margin-top: 0.7rem;
}
.comments-text-description {
  background: $color-maxi 0% 0% no-repeat padding-box;
}

.switch-commnet {
  border: 0.125rem solid $color-sleepy;
}

.comment-negative {
  .switch-commnet {
    border-color: $color-maxi;
  }

  .comments-text-description {
    background-color: $color-sleepy;
  }
}

.comment-mode {
  border-radius: $radius-20;
  width: fit-content;
  line-height: 0;
  span {
    line-height: $line-height-24;
    font-size: $font-size-16;
    font-weight: $font-weight-regular;
  }

  .circle {
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    display: inline-block;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
